import axios from "@/utils/request";

// 查询列表粉丝团
export function queryFansgroup(data) {
  return axios.post(`/fansgroup/joinedlist`, data);
} 